<div class="wrapper">
  <ion-img
    [src]="
      (theme$ | async) === 'dark-theme'
        ? 'assets/images/SC_D_Logo_Horizontal-LM.svg'
        : '/assets/images/SC_D_Logo_Horizontal-DM.svg'
    "
    alt="SquadCast Logo"
    id="logo"></ion-img>

  <ion-row class="card ion-align-items-center ion-justify-content-center">
    <ion-col size-xs="10" size-sm="8" size-md="6" size-lg="5" size-xl="4" class="no-padding-col">
      <div id="badge">
        <ion-icon
          *ngIf="session?.communityEvent !== true"
          src="/assets/icons/24px/quality.svg"
          id="big-icon"></ion-icon>
        <ion-icon
          *ngIf="session?.communityEvent === true"
          src="/assets/icons/24px/community2.svg"
          id="big-icon"></ion-icon>

        <h3 class="bold ion-text-center">{{ session?.communityEvent ? 'Community Event' : 'Backstage Access' }}</h3>

        <p class="ion-text-center body-regular" *ngIf="session?.confType !== 'daily'">
          {{
            session?.communityEvent
              ? 'You will be joining this SquadCast Community Event. This is a private event and you will only be able to see SquadCast Members on stage. You will be able to communicate with us via Chat.'
              : 'You will be joining this recording session in the backstage. This means you will NOT be on Camera or Mic and will only be able to communicate via Chat.'
          }}
        </p>

        <p class="ion-text-center body-regular" *ngIf="session?.confType === 'daily'">
          <strong>Backstage Access is not available for Daily Sessions. Please join the session directly.</strong>
        </p>

        <ion-list lines="none">
          <ion-item class="name-pronoun-container input-small">
            <ion-icon src="/assets/icons/24px/user.svg"> </ion-icon>

            <ion-input
              scAutoFocus
              [(ngModel)]="name"
              (keyup.enter)="joinSession()"
              (ionBlur)="setName()"
              placeholder="Name"
              class="name-field">
            </ion-input>

            <ion-input
              [(ngModel)]="pronouns"
              (keyup.enter)="joinSession()"
              (ionBlur)="setName()"
              placeholder="Pronouns"
              class="pronoun-field">
            </ion-input>
          </ion-item>
        </ion-list>

        <sc-show-session-label></sc-show-session-label>

        <div id="footer">
          <ion-button
            (click)="setupDolby()"
            aria-label="Retry Join"
            *ngIf="retryDolbyInitialize"
            color="tertiary"
            shape="round"
            expand="block"
            size="large">
            Retry
          </ion-button>

          <div *ngIf="!retryDolbyInitialize" class="joinButtonContainer">
            <ion-item [hidden]="dolbyInitialized">
              <ion-progress-bar type="indeterminate" color="secondary" id="loading"> </ion-progress-bar>
            </ion-item>
            <div *ngIf="session?.communityEvent && !countdownHasFinished && session?.activeCommunityEvent">
              <p class="ion-text-center">Community Event will start in</p>
              <p class="ion-text-center body-bold">{{ timeFormatted }}.</p>
            </div>
            <ion-button
              *ngIf="allowIntoTheSession"
              (click)="joinSession()"
              [hidden]="!dolbyInitialized"
              [disabled]="
                !allowIntoTheSession ||
                joining ||
                (session?.communityEvent && !countdownHasFinished) ||
                (session?.communityEvent && session?.activeCommunityEvent !== true)
              "
              aria-label="Join Session"
              id="join"
              class="{{ session?.activeCommunityEvent === false ? '' : 'pulse' }}"
              alt="Start Session"
              color="primary"
              shape="round"
              size="large">
              {{
                session?.communityEvent
                  ? !session?.activeCommunityEvent
                    ? 'Inactive Event'
                    : session?.communityEvent && !countdownHasFinished
                    ? 'Waiting...'
                    : 'Join Community Event'
                  : 'Join Session'
              }}
            </ion-button>
            <ion-button
              *ngIf="!allowIntoTheSession"
              (click)="requestAccess()"
              [hidden]="!dolbyInitialized"
              [disabled]="requestedAccess"
              aria-label="Request Access"
              id="join"
              class="pulse"
              alt="Start Session"
              color="primary"
              shape="round"
              size="large">
              Request Access
            </ion-button>
            <p *ngIf="!allowIntoTheSession && !requestedAccess" class="ion-text-center body-regular">
              It does not seem like you have access to the backstage of this session. Please contact the host or wait to
              be let in.
            </p>
            <p *ngIf="!allowIntoTheSession && requestedAccess" class="ion-text-center body-regular">
              You have requested accessed to the backstage of this session. Please wait for the host to let you in.
            </p>
          </div>

          <ion-button class="text" size="medium" (click)="openSupportCenter()" aria-label="Open Support Center">
            Need help?
          </ion-button>

          <p class="ion-text-center">Follow us on our Socials!</p>
          <ion-row id="social-icons">
            <a
              href="https://join.slack.com/t/squadpodsquad-4xi7003/shared_invite/zt-1ery0i9k6-0w5ThqQ4azIQR_bvjY5Hlw"
              target="_blank">
              <ion-icon src="assets/icons/24px/slack.svg">Slack</ion-icon>
            </a>
            <a href="https://twitter.com/SquadCastFM" target="_blank">
              <ion-icon src="assets/icons/24px/twitter.svg">Twitter</ion-icon>
            </a>
            <a href="https://www.youtube.com/channel/UCZu_5dP2sfvsLhZUrfKK1WQ" target="_blank">
              <ion-icon src="assets/icons/24px/youtube.svg">YouTube</ion-icon>
            </a>
            <a href="https://www.facebook.com/SquadCastFM/" target="_blank">
              <ion-icon src="assets/icons/24px/facebook.svg">Facebook</ion-icon>
            </a>
            <a href="https://www.instagram.com/squadcastfm/?hl=en" target="_blank">
              <ion-icon src="assets/icons/24px/instagram.svg">Instagram</ion-icon>
            </a>
          </ion-row>

          <p class="ion-text-center" id="fine-print">
            <small>
              By clicking Join Session you agree to our
              <a
                href="https://squadcast.fm/terms-conditions/"
                alt="Terms and Conditions"
                target="_blank"
                class="underline"
                >Terms</a
              >
              and
              <a href="https://squadcast.fm/privacy-policy/" alt="Privacy Policy" target="_blank" class="underline"
                >Policies</a
              >.
            </small>
          </p>
        </div>
      </div>
    </ion-col>
  </ion-row>
</div>
